export enum SUPPLY_NODE {
  CUT_FROM_HIGHEST_TIER = 'CUT_FROM_HIGHEST_TIER',
  CUT_FROM_CURRENT_TIER = 'CUT_FROM_CURRENT_TIER',
  ONLY_MINT = 'ONLY_MINT',
}

export enum DEAL_STATUS {
  LIVE = 'LIVE',
  ARCHIVED = 'ARCHIVED',
}

export enum DEAL_STATE {
  PAID = 'PAID',
  UNPAID = 'UNPAID',
}
